module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "chapter01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("One")])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("E")])]), _vm._v("van Powell cursed whatever fate made the doorbell ring when he’d just stepped out of the shower. Working two jobs consumed all of his time and energy. He’d just finished his martial arts workout and relaxing afterward was the only part of his endless day he savored.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The doorbell pealed again. He wanted to get it before his dad woke. Damn.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Wrapping a large brown towel around his waist, he glimpsed his own visage in the mirror. He looked like a harsh man. The kind of man who’d lived a hard life. He knew the mirror didn’t lie. If anything it softened his image.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_vm._v("He hoped to God one of his deputies was ringing ")]), _c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_vm._v("the bell. Maybe Hobbs, his newest recruit, who was still wet behind the ears. A neighbor or tourist would probably run for the hills, seeing him. Except Florida didn’t have hills, he thought.")])]), _c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He stalked through the dark house. The grandfather clock in the hall chimed one o’clock. If his favorite cow hadn’t chosen tonight to give birth he’d already be in bed and resting. Only an emergency would bring someone out at this time of night.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He should take time to grab some pants, he thought. But he wasn’t feeling hospitable and didn’t really feel like making the effort of dressing. He paused by the locked gun cabinet in the living room to grab his weapon. The .45 felt right in his hand, something he never examined too closely.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Pants were an option but his gun wasn’t. When had life been brought down to survive or die? he wondered. He knew it had a lot to do with the training he’d received in Quantico.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He flicked on the porch light, then swung the door open, hiding the gun behind the barrier of wood and glass. A slender woman with slicked-back blond hair stood in the doorway. A gash on her head bled slowly, and her deep blue eyes were wide with shock.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_vm._v("“I wrecked my car,” she said. Her voice had a slightly high pitch and no accent. She wavered on her feet, and he reached out to steady her. The feel of expensive silk beneath his fingers was foreign. For a moment he wanted to enjoy the sensation of caressing luxury, but he couldn’t. People who stared through ")]), _c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_vm._v("shop windows at things they couldn’t have only ended up drooling on themselves.")])]), _c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Where?” he asked, reminding himself he was the sheriff and had sworn to protect and serve civilians.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She gestured wildly toward the long, winding driveway and the highway. Had she walked from the wreck? She had to be exhausted.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The harsh fluorescent lamp was punishing, revealing her shock and fatigue in stark detail. Her skin looked so fine it seemed almost translucent. He wanted to touch her. Her flesh couldn’t be as soft as it looked. Annoyed, he realized she aroused him. He must be more tired than he thought if this woman was slipping past his guard.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She should have appeared chic and sophisticated, if her clothes and haircut were any indication, and to some extent she did. But there was an air of fragility and innocence about her. Not the debauched boredom that he’d encountered countless times in the rich.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Those emotions were oddly out of step with what he expected of her type. His ex-wife Shanna had the same sleek look about her but absolutely no fragility or innocence. In fact, Shanna was a barracuda, swimming through the masses of men who thronged around her in search of a weak one to kill.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Where’s your car?” he repeated.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_vm._v("“At the edge of your property, at least I think it’s your property. Do you own the Rockin’ PJP Ranch? There was a cow and a…” Her voice trailed off as ")]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("her gaze swept down his body, and she realized he wore only a towel.")])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When her eyes widened, he saw a hint of female speculation in her gaze before fear entered. She struggled to free herself, pulling frantically on her arm. He set his gun on the hall table. He held her shoulders in both of his hands, afraid she’d fall down the porch steps and further injure herself in her frantic bid for escape.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Hold still, dammit. I’m not going to hurt you.” It was odd that he had to reassure her. Being the local law meant that most people turned to him for protection. Though he knew the lack of a uniform probably had a lot to do with her reaction. He wasn’t a safe-looking guy. He was a tough hombre, he thought, remembering his wisecracking deputy’s description.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Still, damn few people ran from him. If they did, they had a reason. This little lady sure didn’t have anything to fear from him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She aimed him a haughty look, bringing the poise and elegance he’d only speculated about earlier to the fore.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Evan released her and spread his hands wide. “I’m the sheriff.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Where’s your badge? And no, I don’t want to see your stick.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Evan bit back the laughter rising in his throat. He liked this feisty woman even though she’d disturbed his peaceful night.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("He wanted to touch her again. To see if she reacted ")]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("as quickly to passion as she did to anger. He wished he’d slid his palms down her arms before he’d released her. He’d bet his next month’s pay she’d be soft and smooth. She had that pampered look.")])]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Don’t run off. I’ll go get my pants and my badge, and we’ll go see about your car.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Okay,” she said, her body relaxing. The shocked expression left her and a tentative half-grin lit her face.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Do you want to wait inside or would you feel safer on the porch?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’ll wait out here.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He couldn’t blame her. Though he knew he meant her no harm, she had to trust and depend on herself for protection until he proved himself harmless.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We’ve got two dogs who have the run of the place so if they show up while I’m gone don’t be alarmed. They’re all bark,” he said as he headed for the stairs.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Like their owner,” she muttered.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Though he knew her words hadn’t been intended to reach him, he pivoted and walked back toward her. “I’m not all bark.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She held her spine stiff and straight in a way that reminded him of a proud twenty-year Marine. When she spoke, the sparkle in her eye reassured him her injury wasn’t too serious. “I didn’t say you were.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He reached out with his free hand brushing a finger down the side of her cheek. Dammit, she was as soft as he’d suspected. “Sure you did, sweetheart. You just hoped I wouldn’t hear.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("He backed away, knowing if he stayed too close ")]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("he’d be tempted…. Tempted to touch her again with his mouth. Tempted to pull her soft curvy body into the hard muscles of his. Tempted to forget his good sense and take what her snapping eyes didn’t know they offered.")])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“If I didn’t want you to hear, I wouldn’t have said it out loud.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He liked her grit. “I’m your only hope of not standing outside all night, so you might want to remember that.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I will. I’m sorry. I’m just tired and scared.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Evan softened toward her. She seemed delicate and he wanted to comfort her. How many times did he have to learn the same lesson? Although he was torn, he knew better.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Women weren’t the weaker sex, as men had stupidly assumed for eons. They were a powerhouse. And no one knew that better than Evan Powell.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’s okay. I do resemble the dogs in some ways.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Which ways?” she asked, her eyes alight with curiosity instead of shock.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("I’m loyal and trustworthy,")]), _vm._v(" he thought. But didn’t say it out loud because it would leave him vulnerable. “I’ll let you figure it out.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He turned to go, knowing he shouldn’t make a parting comment, but he couldn’t help himself. “By the way, sweetheart. I don’t show my "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("stick")]), _vm._v(" to just anyone.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("Evan left her out in the night air but didn’t close the door. She might change her mind about coming ")]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("inside once he left. He took his gun with him, locking it back in the cabinet before going upstairs to dress. He never left his guns unlocked.")])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He thought about the woman waiting for him on his front porch. She screamed big city. The kind of lady he knew better than to tangle with, yet part of him wanted to do just that. He wanted to take care of her wound, then comfort her in his arms.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Dammit, old son, haven’t you already learned that lesson?")]), _vm._v(" He didn’t answer himself.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lydia couldn’t believe she stood on the porch of some backwoods sheriff’s house. Florida was surprisingly cold on this May night and frightening. Foreign noises grew in volume in the darkness, and she couldn’t hear a single car honking or taxi driver cursing. This remote place was nothing like her aunt’s place farther south in Deerfield Beach.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But it wasn’t all an unpleasant experience. The scent of orange blossoms filled the air, and the full moon painted pretty shadow pictures on the ground. Taking a deep breath, she stared up at the sky.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She shivered and ran her hands over her bare arms. Her short-sleeved designer pantsuit might look nice indoors, but outside it offered no protection. Expensive but worthless. Like her?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("That line of thinking was too depressing to pursue. Her car was wrecked. She couldn’t give her name or any other information to the cops. They’d call her father, and she couldn’t go home. At least not yet.")])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("After the accident, she’d listened to the warning bell telling her the car door was ajar, realizing that something inside her was ajar. She couldn’t go back home. She couldn’t continue on to Aunt Gracie’s house either because her car was totaled. The future was already written in stone, and it looked long and lonely from where she sat.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She’d have to wing it. But she wasn’t good at spur-of-the-moment things. The last time she’d tried to be spontaneous she’d discovered her fiancé in bed with his mistress. No, she thought, don’t go there.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She hadn’t loved Paul Draper but she’d liked him and thought they’d have a chance at a decent sort of marriage. But Paul hadn’t believed in commitment to one woman, especially a wife.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Catching Paul in bed with another woman hadn’t broken her heart, but it had made her think about marrying for any reason other than love. She’d quietly left Paul’s apartment and informed her father that she wasn’t rushing into marriage. For the first time he’d gotten truly angry with her and insisted she would marry Paul. Feeling trapped Lydia had escaped in the middle of the night with no clear plan of where she was going—only knowing she couldn’t stay in New York City.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("She’d looked into the darkening night and made a desperate decision to change the course of her fate. She was going to have to be in the driver’s seat if she didn’t want to take that long, lonely walk down the marriage aisle in September. She had this summer. ")]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("One short summer to find an alternative and to find "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("herself")]), _vm._v(" before she had to make a decision to either submit to her father’s vision of her destiny or change her life forever. During the long walk to the ranch house she’d vacillated, not coming up with any solution, but one thing had been clear—her determination not to play the role her father had chosen for her.")])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She’d always been close to her father, and they’d grown closer in the last ten years since her mother’s death. Close enough for her to have been fooled by him when he said that she should marry for love and not position.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She was the child of an illicit affair and had lived in a posh Manhattan penthouse with both of her parents all her life, even though they’d never married. She’d gone to an exclusive boarding school with children of rock stars and politicians so her parents not being married had never been an issue. Actually, her family had been closer to normal than any.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her father would drag her back home, and she’d be forced to marry Paul. She would have thought her father had enough respect for her at twenty-five to let her make her own decisions. But no.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Two months ago he’d come home from the office and announced that she should be married in six months. He’d asked if she had any prospects. Thinking he was joking she’d said no, she was going to be an old maid.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("From that moment on her father had shoved one single executive after another down her throat. She’d ")]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("been on more blind dates and accidental dinners than she’d ever wanted. And it had soon become clear that these men weren’t interested in her as anything other than the means to an end.")])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She wanted to find her Prince Charming and be swept off her feet by him. She’d come to realize that in real life the handsome, wealthy prince might not be the greatest catch. He might be self-absorbed and cold. Her real-life, handsome, wealthy prince would certainly never banter with her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She didn’t want to be married off for her position in society, to a man who saw her only as a bank account, she thought sadly. It made her wonder what, if anything, Paul wanted from her. He was her father’s second in command at work. He really had nothing to gain by marrying her. Except a lot of money.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Oh, great. She was getting maudlin. She was too young and spunky to be so melodramatic, she reminded herself. But the lesson didn’t sink in. Tonight, she was tired and cold and her head ached. Taking a deep breath, she sank down onto one of the porch steps. She wanted to bury her face in her hands, but the wound on her head prohibited that. So she rested her chin on her up-drawn legs.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When the good-looking sheriff came back she was going to have to lie for all she was worth to convince him she was nothing more than she appeared. A down-on-her-luck-lady.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("She loved her dad, but she wasn’t ready to go back to Manhattan yet. He was too steely-eyed in his de")]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("termination for her to marry Paul. She’d left him a note with a brief admonition not to worry, but she knew him. Martin Kerr wasn’t going to let her stay hidden.")])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She wondered if the sheriff would believe she had amnesia? She doubted it. Besides, on the soaps, amnesia victims were always immediately unsure of where they were and what they were doing. She’d probably blown her chance. Frankly, she didn’t know if she was up to inventing a complicated lie.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Simplicity seemed her smartest route. She’d already removed her license plate and hidden it in her suitcase so they couldn’t trace the car to her New York address. She’d also left her cell phone behind, knowing she’d answer it if her dad called and she needed distance to think. She’d have to make up a name and a story. A good one because, even though this was a small-town sheriff, keen intelligence had gleamed in his eyes. Also a predatory awareness that she’d rarely encountered in men. He wasn’t going to be distracted by batting eyelashes and fingers stroking down his arm.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She liked the sheriff. Liked the lean body she’d observed while he’d talked with her. Liked the line of hair that tapered down his washboard stomach beneath the line of the brown towel. Liked the easy strength he’d used to hold her with when she’d tried to escape. Liked especially the fact that he hadn’t hurt her.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("She heard feet pounding the earth, and a minute later two monsters surrounded her. Dogs were cute fluffy white things with pink or yellow bows in their ")]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("hair. These dirty phantoms wanted to eat her alive, she realized as wet coarse tongues swept over her arms and face.")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She screamed and tried to scramble to her feet. A strong hand grabbed her upper arm, steadying her. Grateful for the sheriff’s assistance she clung to him. She felt tears burn the back of her eyes and felt not only the helplessness of her current situation, but also the weight of her life and the decision she’d made.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Settle down, boys,” the sheriff ordered, appearing by her side.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The dogs stilled and then, after a hand movement from the sheriff, disappeared around the corner. Lydia could hardly contain her breathing. The sheriff ran a soothing hand down her spine.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“So you don’t like dogs?” he asked, in a laconic drawl that made her want to kick him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I like show dogs. Pets with manners,” she said. To her own ears her voice sounded thin and airy. Did she sound that weak to him?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Those are real dogs for real men, sweetheart. Not the cultured kind of pet you find in the city.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“How did you know I’m from the city?” she asked. Oh, God, did he know who she was? For the first time since he’d rejoined her, she studied him.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("Her breath caught in her throat. If he’d been sexy wearing only a towel, he was even more so clothed in a black T-shirt and faded jeans. She liked the smile in his eyes and the quiet confidence he projected. She didn’t want to like him because she had to deceive ")]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("him, but she knew there was little hope for resisting him.")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He shrugged his shoulder and scratched his chin before answering her. “You just have the look of the city.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He had no idea how right he was. She did have "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("the look")]), _vm._v(", had, in fact, been part of a national campaign with her supermodel mother when she was fifteen. Lydia bit her lip as thoughts of her mother assailed her. Her mother had been killed in the terrorist downing of a plane.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I didn’t realize bloody wounds and rumpled clothing were in fashion this year,” she quipped.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Maybe you’ll start a trend.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She doubted it. She hated the spotlight. Uncomfortable with the silence between them, she diverted the conversation to business. “I should have asked you for a phone earlier to call a wrecker.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I already took care of that. And I’ve called one of my deputies and an ambulance. They’ll be waiting for us by your car. Here’s my badge, by the way,” he said, quickly extending the badge for her to see. “Come on, I’ll give you a ride back to your vehicle.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Thanks.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She’d always had everything she wanted but riding in a 4X4 would be a new experience. If she’d walked back to her car, her feet would have protested. His big truck sported a little step built under the door. Thank God, she thought. Otherwise she wouldn’t have been able to climb inside without help.")])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The sheriff stood behind her anyway and boosted her to the step. She seated herself, then realized they were eye-to-eye. He was a tall man, this sheriff. His eyes were an icy gray. The play of light over his features fascinated her. A strong jaw and sun and laugh lines that radiated outward from his eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A real man. A shiver of awareness spread through her body and pooled at her center. She’d bet her last hundred-dollar bill that he had the kind of muscles you couldn’t get with weekly trips to the fitness center. Stop it, she warned herself.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She’d never been on her own, and the prospect was daunting. For a moment she wanted to return to the familiar, her prestigious name and large bank account. But she also wanted the chance to prove to herself that she was more than a commodity to be sold to the highest bidder.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Thank you, sir.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m Evan Powell. Please call me Evan,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Thank you, Evan.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’re welcome….”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He wanted to know her name. Come on girl, think. The safest name would be her own. She’d use her middle name, which was what her closest friends called her anyway. She’d give her father’s name for the last name. “Lydia Martin.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Lydia,” he repeated her name as if savoring the feel of it on his tongue.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("He closed the door. She watched him walk around the truck and sucked in a few deep breaths before he ")]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_vm._v("returned. The cab smelled warm and masculine. Like his aftershave, she realized as he climbed behind the wheel.")])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He started the truck and the twang of country guitar filled it. He reached out to turn down the volume and she watched his hands. Twice he’d held her arm. She wondered what his touch would feel like in a different context and not on her arm. Her nipples tightened against her lacy bra.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Are you visiting around these parts?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Glad for the distraction from her thoughts, she said, “No, I’m just passing through. I was heading to Deerfield Beach to stay with my aunt.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("They’d reached the end of his driveway. “Which way?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Left.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her BMW was still wrapped around a telephone pole, and the wreck looked a lot worse in the harsh light cast by his 4X4 truck. “I’m surprised you were able to walk away.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The air bag and seat belt saved my life,” she said and knew it was true.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_vm._v("Amazing she’d survived, she thought as she stared at the twisted pile of metal. She felt as if she’d been given another chance at life, and she decided to make the most of it. If she wanted to marry for love she’d have to find a man worthy of her love—and find out if she was worthy of his love. The ideas she’d been playing with earlier solidified, and she knew a sense of purpose for the first time in her life. And that pur")]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_vm._v("pose was going to take her in the opposite direction to where her life had been heading.")])]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The police, ambulance and wrecker all arrived while she watched from the cab of Evan’s truck. She felt a little like a fairy-tale princess who’d just been awakened from a long sleep. Only this princess would travel a harder road to find her knight in shining armor and live happily ever after.")])])]), _c('a', {
    attrs: {
      "id": "page22"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page22"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5797b5a9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781459206557_chapter01.vue
// module id = 81
// module chunks = 0